module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-01.37974fc0.png";